import { type Position, patchPositionsDisplayOrder, patchPersonPositionsDisplayOrder } from 'services'
import {
  Typography,
  CircularProgress,
  Box
} from '@mui/material'
import React from 'react'
import { DragAndDropStack, PositionCard } from 'components'
import { type HttpResponse } from 'interfaces'

interface PositionsStackProps {
  orgId?: number
  personId?: number
  loading: boolean
  positions: Position[]
  triggerReload: () => Promise<void>
}
export const PositionsStack: React.FC<PositionsStackProps> = ({ orgId, personId, positions, loading, triggerReload }) => {
  const changeDisplayOrder = async (items: Position[], positionSelected: Position): Promise<HttpResponse<Position[]>> => {
    if (orgId != null) {
      return await patchPositionsDisplayOrder(orgId, items, positionSelected.id)
    } else if (personId != null) {
      // eslint-disable-next-line @typescript-eslint/return-await
      return await patchPersonPositionsDisplayOrder(personId, items, positionSelected.id)
    }
    throw new Error('Failed to update display : Must Have OrgId or PersonID')
  }

  const renderCard = (item: Position, index: number): React.ReactNode => {
    return <PositionCard index={index} createCard={false} originalPosition={item} triggerReload={triggerReload} displayOrgLink={personId != null}/>
  }

  if (loading) {
    return (<Box display="flex" justifyContent="center" alignItems="center" height="100%">
    <CircularProgress />
  </Box>)
  }
  return (
            <React.Fragment>
              {positions.length === 0 && <Typography> No Positions to Show</Typography>}
            <DragAndDropStack
              id={'position-stack'}
              originalItems={positions}
              itemRenderer={(item: Position, index: number) => renderCard(item, index)}
              updateDisplayOrder={async (items: Position[], positionSelected: Position) => await changeDisplayOrder(items, positionSelected)}
              disableDrag={positions.length <= 1}
              makeGray={false}
            />
            </React.Fragment>

  )
}
